import TipoVoto from '@/dominio/TipoVoto';
import Configuracao from '@/util/Configuracao';
import DataUtil from '@/util/DataUtil';
import { MEIO_JULGAMENTO_PROCESSO } from './MeioJulgamentoProcesso';
import SituacaoVoto, { SITUACAO_VOTO } from './SituacaoVoto';

/**
 * @classdesc Regras de negócios relacionadas à votação.
 * @readonly
 */
export default class VotacaoBusiness {
    static isPreVoto(voto) {
        return voto.situacaoVoto && voto.situacaoVoto === SITUACAO_VOTO.PRE_VOTADO.id;
    }

    static getDescricaoVoto(voto) {
        if (!voto.situacaoVoto || voto.situacaoVoto === SITUACAO_VOTO.NAO_CONFIRMADO_PRESENCIAL.id) {
            return 'Voto indisponível';
        }

        if (voto.situacaoVoto === SITUACAO_VOTO.PRE_VOTADO.id) {
            return SITUACAO_VOTO.PRE_VOTADO.descricao;
        }

        return voto.voto.descricao;
    }

    static getCorVoto(voto) {
        if (!voto.situacaoVoto || voto.situacaoVoto === SITUACAO_VOTO.PRE_VOTADO.id) {
            return SITUACAO_VOTO.SEM_VOTO.cor;
        }

        return TipoVoto.getCorByCodigo(voto.voto.codigo);
    }

    static getObjDetalhesVoto(voto, codigoMeioJulgamentoProcesso) {
        if (!voto || voto.situacaoVoto === SITUACAO_VOTO.SEM_VOTO.id) {
            return null;
        }

        let votoConsiderado;

        if (
            Configuracao.OCULTAR_VOTACAO_SESSAO_PRESENCIAL &&
            codigoMeioJulgamentoProcesso &&
            codigoMeioJulgamentoProcesso !== MEIO_JULGAMENTO_PROCESSO.VIRTUAL.codigo &&
            codigoMeioJulgamentoProcesso !== MEIO_JULGAMENTO_PROCESSO.VIRTUAL_REMETIDO.codigo
        ) {
            votoConsiderado = {
                ...voto,
                situacaoVoto: SITUACAO_VOTO.NAO_CONFIRMADO_PRESENCIAL.id,
                dataConfirmacao: undefined,
                voto: {
                    codigo: SITUACAO_VOTO.NAO_CONFIRMADO_PRESENCIAL.codigo,
                    descricao: SITUACAO_VOTO.NAO_CONFIRMADO_PRESENCIAL.descricao
                }
            };
        } else {
            votoConsiderado = voto;
        }

        const isPreVoto = this.isPreVoto(votoConsiderado);
        const dataFormatada = votoConsiderado.dataConfirmacao
            ? DataUtil.formatarData(votoConsiderado.dataConfirmacao)
            : null;

        return {
            cor: this.getCorVoto(votoConsiderado),
            descricao: this.getDescricaoVoto(votoConsiderado),
            podeExibir: !isPreVoto,
            situacao: isPreVoto
                ? null
                : {
                      id: votoConsiderado.situacaoVoto,
                      descricao: SituacaoVoto.getDescricao(votoConsiderado.situacaoVoto),
                      cor: SituacaoVoto.getCor(votoConsiderado.situacaoVoto),
                      dataConfirmacao: dataFormatada
                          ? `Voto confirmado em ${dataFormatada}`
                          : 'Sem data de confirmação do voto'
                  }
        };
    }
}
